export default __webpack_public_path__ + "images/98ef1d24c605cf1937bca934c9875648-edit.svg";